/* eslint-disable no-console */
import { site, asyncFetchGet, asyncFetchPost, asyncFetchDelete, getCookie } from './global.js'
import moment from 'moment'
import {
    getHomeworkListByClass, postHomework,
    getHomeworkById, getHomeworkWithCommentsById,
    deleteHomeworkById,
    postHomeworkComment,
    getAnswerListByHomework, setAnswerScore, getStudentScore, postAnswer
} from './homeworks'

// 登录。需提供用户名和密码
export async function tryLogin(username, password) {
    try {
        const response = await fetch(site + 'token-auth/', {
            method: 'POST',
            body: JSON.stringify({
                username,
                password
            }),
            headers: {
                'X-CSRFToken': getCookie('csrftoken'),
                'Content-Type': 'application/json'
            }
        });
        const result = await response.json();
        return result;
    } catch (error) {
        console.log(error);
    }
}


export const getClassrooms = () => asyncFetchGet('classes')

export const getClassroomById = (id) => asyncFetchGet('classes', `/${id}/`)


export const getMembersByClass = (id) => asyncFetchGet('class-members', `/${id}/`);


export async function postDiscussionComment(content, discussionId, userId) {
    // content-type: 14 -> discussion
    const res = await asyncFetchPost('comments', {
        content_type: 14,
        object_id: discussionId,
        content,
        author: userId
    });
    return res;
}

export const postReply = (content, userId, parentCommentId, replyToId = null) => {
    return asyncFetchPost('replies', {
        content,
        author: userId,
        parent_comment: parentCommentId,
        reply_to: replyToId
    });
}

export const getDiscussionListByClass = (class_id) => asyncFetchGet('discussions', `/?belonged_class=${class_id}`)

export async function postDiscussion(name, description, classId, authorId, attachment) {
    const formData = new FormData();
    formData.append('name', name);
    formData.append("description", description);

    formData.append("belonged_class", classId);
    formData.append("author", authorId);
    formData.append("attachment", attachment);
    const response = await fetch(site + "discussions/", {
        method: "POST",
        headers: {
            Authorization: "Token " + localStorage.getItem("token")
        },
        body: formData
    });
    const result = await response.json();
    return result;
}

export const deleteDiscussion = (id) => asyncFetchDelete('discussions', id);

export async function getDiscussionWithCommentsById(id) {
    const response = await asyncFetchGet('discussions', `/${id}/`);
    const { name, description, release_time, author_info: author, comments, attachment } = response;

    const resolvedComments = comments.map(comment => {
        const { content, child_comments, publish_time, author, id } = comment;
        const replies = child_comments.map(reply => {
            const reply_from = {
                name: reply.from_user_obj.full_name,
                avatar: reply.from_user_obj.avatar
            };
            let reply_to = undefined;
            if (reply.reply_to && reply.to_user_obj) {
                reply_to = {
                    name: reply.to_user_obj.full_name,
                    avatar: reply.to_user_obj.avatar
                };
            }
            return {
                id: reply.id,
                content: reply.content,
                publish_time: moment(reply.publish_time).format("MMM Do, YYYY, HH:mm"),
                from: reply_from,
                to: reply_to
            }
        });

        return {
            id,
            content,
            publish_time: moment(publish_time).format("MMM Do, YYYY, HH:mm"),
            from: {
                name: author.full_name,
                avatar: author.avatar
            },
            replies
        };
    });

    return {
        name,
        description,
        attachment,
        release_time: moment(release_time).format("MMM Do, YYYY, HH:mm"),
        author: {
            name: author.full_name,
            avatar: author.avatar,
        },
        comments: resolvedComments
    };
}


export {
    getHomeworkListByClass, postHomework,
    getHomeworkById, getHomeworkWithCommentsById,
    deleteHomeworkById,
    postHomeworkComment, getAnswerListByHomework, setAnswerScore, getStudentScore, postAnswer
}
